// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6926) return "static/chunks/2980a27f-b9db952999ff4ac6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2229":"d9a3e9686da42473","4822":"47a7fb04f2a93a88"}[chunkId] + ".js";
};